/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React from "react";
import { useSetRecoilState } from "recoil";
import { getUser } from "../api/User";
import { UserAtom } from "../atoms/UserAtom";
import StripeProvider from "./Modal/container/Billing/StripeProvider";
import { useModal } from "./Modal/Modal";

const Container = styled.div`
  height: 80vh;
  width: fit-content;
  overflow: scroll;
`;

export default function UpdateBillingModal() {
  const setUser = useSetRecoilState(UserAtom);
  const modal = useModal();

  return (
    <Container>
      <StripeProvider
        onCancelClicked={() => modal.popModal()}
        onOkClicked={async () => {
          const newUser = await getUser();
          modal.popAll();
          setUser(newUser);
        }}
      />
    </Container>
  );
}
